'use strict'

const initialState = { }

const splitTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALISE_TEST':
      state[action.data.name] = { active: action.data.status }
      return state
    case 'INJECT_TEST_DATA':
      if (!state.hasOwnProperty(action.data.name)) return state
      Object.assign(state[action.data.name], action.data.newSplitTestData)
      return state
    default:
      return state
  }
}

module.exports = splitTestReducer



// WEBPACK FOOTER //
// ./shared/stores/splitTest.js